var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router';
function Breadcrumb(_a) {
    var breadcrumbs = _a.breadcrumbs;
    return (_jsx("nav", __assign({ className: "flex items-center justify-start flex-wrap gap-y-3xs-m text-sm-med-m md:text-sm-med-d text-text-body" }, { children: _jsxs("ul", __assign({ className: "shrink-0" }, { children: [breadcrumbs.map(function (breadcrumb, index) { return (_jsxs("li", __assign({ className: "inline-block" }, { children: [_jsx(Link, __assign({ to: breadcrumb.href, viewTransition: true }, { children: breadcrumb.label })), _jsx("span", __assign({ className: "m-3xs-m" }, { children: "/" }))] }), index)); }), _jsx("li", __assign({ className: "inline-block" }, { children: "Article" }))] })) })));
}
export default Breadcrumb;
